<template>
    <modal :ref="'appChat'" :name="'appChat'" :draggable="'.drag-handle'" :resizable="true" :clickToClose="false" :scrollable="true" :height="'70%'" :minWidth="300" :width="panelWidth" :reset="true" @opened="opened" @closed="closed" @before-open="beforeOpen">
        <div id="app-chat" class="container-fluid chat w-100 h-100" :class="chatState === 'chat-float' ? 'shadow' : ''">
            <div class="row h-100">
                <div class="col p-0" v-if="openDiscussion">
                    <discussion :discussion="openDiscussion" @closeDiscussion="closeDiscussion" />
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Discussions',
  data () {
    return {
      openDiscussion: null,
      panelWidth: 300
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      chatState: state => state.chatState,
      discussions: state => state.discussions,
      resourceState: state => state.discussionsState
    })
  },
  mounted () {
    this.$modal.show('appChat')
    this.index()
  },
  methods: {
    ...mapActions([
      'toggleChat',
      'closeChat'
    ]),
    index (page, count) {
      if (page) this.$store.commit('pushState', { view: this.$options.name, key: 'page', data: page })
      else page = this.resourceState.page
      if (count) this.$store.commit('pushState', { view: this.$options.name, key: 'tableRows', data: count })
      else count = this.resourceState.tableRows
      this.loading = true
      this.$store.dispatch('index', { collection: this.$options.name, params: { page: page, count: count } }).then(() => {
        this.loading = false
        this.panelWidth = 600
      })
    },
    closeDiscussion () {
      this.openDiscussion = null
      this.panelWidth = 300
      this.$modal.hide('appChat')
      this.$modal.show('appChat')
    },
    initializeSize () {
      this.$refs.appChat.setInitialSize()
    },
    beforeOpen (event) {
      this.$emit('before-open', event)
    },
    show () {
      this.$modal.show('appChat')
    },
    hide () {
      this.$modal.hide('appChat')
    }

  }
}
</script>
